import * as uuid from "uuid";
import * as angular from 'angular';

export namespace TagLabels {
    export var Currency = "currency";
    export var InvoiceTotal = "total";
    export var InvoiceBalance = "balance";
}

export namespace SystemIndicators {
    export var Currency = 8;
    export var UsageQuantity = 1;
    export var UsageUnitFee = 2;
    export var UsageTotalFee = 16;
    export var RightsStartDate = 5;
    export var RightsEndDate = 6;
    export var RoyaltyIncomeGroup = 13;
    export var Allocation = 1000;
    export var Amortization = 1001;
    export var AmortizedAmount = 1005;
    export var PaymentSchedule = 1055;

    export namespace Amount {
        export var Amount = 7;
        export var Currency = 8;
    }

    export namespace Rightset {
        export var territory = 2;
        export var media = 1;
        export var language = 3;
        export var channel = 4;
    }
}

export namespace DocumentIndicators {
    export var DocumentGeneration = 1;
    export var SendForSignature = 2;

}
export namespace CharacteristicIDs {
    export namespace Rights {
        export var Media = 1;
        export var Territory = 2;
        export var Language = 3;
        export var Channel = 4;
    }
}

export enum BulkEditHierarhcyMode { Remove = -1, Replace = 0, Add = 1 };
export enum SecurityPolicyType { None = -1, Activity = 0, Data = 1, Workflow = 2, Admin = 3 };
export enum RelationshipIndicator { Default = 0, Inherited = 1 }

export namespace Events {
    export var QuickLinksRefresh = "quicklinks:refresh";
    export var NotifyDone = "notify:done";
    export var NotifyStart = "notify:start";
    export var ContractRefreshAll = "contract:refreshall";
    export var ValidateEntity = "entity:validate";
    export var WorkflowExecuted = "entity:workflowexecuted";
    export var DocumentGenerated = "entity:documentgenerated";
    export var ContactsRefreshed = "contact:refreshed";
    export var KeyArtSave = "keyart:save";
    export var EntityRelationshipsLoading = "entity:relationshipsloading";
    export var EntityRelationshipsLoaded = "entity:relationshipsloaded";

    export var TreeListFilterReset = "treelist:filterreset";
    export var TreeListShowSelected = "treelist:showselected";
    export var JobRefreshAll = "job:refreshall";
    export var ProjectRefreshAll = "project:refreshall";

    export var EntityAssociationSearchRefreshAll = "entityAssociation:refreshall";

    export var RLDropPanelOpening = "droppanel:opening";
    export var RLDropPanelClose = "droppanel:close";

    export var CopyEntitySuccessful = "entity:copy";
    export var RefreshDealDetails = "entity:refreshDealDetails";
    export var ViewEntity = "entity:viewEntity";
    export var ViewEntityRelationshipPair = "entity:viewEntityRelationshipPair";
    export var UpdateStatusHistory = "entity:viewStatusHistory";
    export var RefreshPreviewEntity = "summary:refreshPreviewEntity";
    export var NewViewCreated = "newViewCreated";
    export var RefreshTables = "entity:refreshTables";
    export var RefreshTablesAndParents = "entity:refreshTablesAndParents";
    export var RefreshComments = "comments:refresh";

    export var CanCalculateAllocation = "table:canCalculateAllocation";
    export var CalculateAllocationRequest = "table:calculateAllocationRequest";
    export var AllocationRowSelectionChanged = "table:AllocationRowSelectionChanged";
    export var CanCalculateAmortization = "table:canCalculateAmortization";
    export var CalculateAmortizationRequest = "table:calculateAmortizationRequest";
    export var CalculateAmortizationResponse = "table:calculateAmortizationResponse";

    export var IncomeGroupsChanged = "royalty:IncomeGroupsSelectionChanged";
    export var RoyaltySplitsChanged = "royalty:RoyaltySplitsChanged";

    export var DeleteConditionalField = "conditionalfield:delete";
    export var RefreshViewEntity = "entity:refreshViewEntity";
}

export namespace Urls {
    export var ContractListPage = "/Contract";
    export var FinancialListPage = "/Financial";
    export var ContactListPage = "/Contact";
    export var InventoryListPage = "/Inventory";
    export var PropertyListPage = "/Asset";
    export var JobListPage = "/Job";
    export var ProjectListPage = "/Project";

    export var CreateAndAssociateHierarchicalRecords = "/CreateAndAssociateHierarchicalRecords";
}

export namespace AttachmentTypes {
    export var KeyArt = 1;
    export var SmallThumb = 2;
    export var Original = 3;
    export var Other = 4;
}

export namespace AttachmentTypeNames {
    export var KeyArt = "Key Art";
    export var SmallThumb = "Thumbnail";
    export var Original = "Original";
    export var Other = "Other";
}

export namespace AttachmentTypeDicts {
    var ids = {};
    ids[AttachmentTypeNames.KeyArt] = AttachmentTypes.KeyArt;
    ids[AttachmentTypeNames.SmallThumb] = AttachmentTypes.SmallThumb;
    ids[AttachmentTypeNames.Original] = AttachmentTypes.Original;
    ids[AttachmentTypeNames.Other] = AttachmentTypes.Other;
    export var IDs = (() => { return ids; })();

    var sizes = {};
    sizes[AttachmentTypes.KeyArt] = 2 * 1024 * 1024;//2Mb
    sizes[AttachmentTypes.SmallThumb] = 5 * 1024 * 1024;//5Mb
    sizes[AttachmentTypes.Original] = 1024 * 1024 * 1024;//1Gb
    sizes[AttachmentTypes.Other] = 1024 * 1024 * 1024 * 1024;//1Tb
    export var MaxSizes = (() => {
        return sizes;
    })();

    var mimeTypes = {};
    mimeTypes[AttachmentTypes.KeyArt] = ['image/*'];
    mimeTypes[AttachmentTypes.SmallThumb] = ['image/*'];
    mimeTypes[AttachmentTypes.Original] = null;
    mimeTypes[AttachmentTypes.Other] = null;
    export var MimeTypes = (() => { return mimeTypes; })();
}

export namespace DocGenFormats {
    export var PDF = "PDF";
    export var DOCX = "DOCX";
}

export namespace TemplateGroupIDs {
    export var IntellectualPropertyTemplateGroup = 1;
    export var InventoryItemTemplateGroup = 2;
    export var DealCatalogLevelUsageTemplateGroup = 2;
    export var CatalogLevelUsageTemplateGroup = 3;
    export var JobTemplateGroup = 3;
    export var RightslineDocTemplateGroup = 1;
    export var UsageModuleLevel = 1;
    export var DocumentFolderTemplateGroupID = 3;
}

export namespace AccessRight {
    export var None = 0;
    export var Read = 1 << 0;
    export var Write = 1 << 1;
    export var Create = 1 << 2;
    export var Delete = 1 << 3;
    export var Admin = 1 << 4;
    export var Restrict = 1 << 5;
    export var All = Read | Write | Create | Delete | Admin;
    export var FlagArray = [Read, Write, Create, Delete, Admin, Restrict];
}

export namespace AccessResult {
    export var NotSet = 0;
    export var Allow = 1;
    export var Deny = -1;
}

export namespace Acl {
    export var ValueParam = "value";

    export var AclProtocol = "acl";

    var activityHost = AclProtocol + "://activity";
    var site = activityHost + "/site";
    var mod1 = site + "/mod1";
    var mod17 = site + "/mod17";
    var mod2 = site + "/mod2";
    var mod4 = site + "/mod4";
    var mod7 = site + "/mod7";
    var mod14 = site + "/mod14";
    var mod15 = site + "/mod15";
    var mod16 = site + "/mod16";
    var reports = site + "/reports";
    var configuraton = site + "/configuration";

    var adminHost = AclProtocol + "://admin";
    var admin = adminHost + "/admin";

    var details = "/details";
    var contacts = "/contacts";
    var association = "/association";
    var associationv2 = "/association-v2";
    var deals = "/deals";
    var media = "/media";
    var rights = "/rights";
    var security = "/security";
    var accounting = "/accounting";
    var accountingsummary = "/accountingsummary";
    var royalties = "/royalties";
    var assets = "/assets";
    var inventory = "/inventory";
    var projects = "/projects";
    var documents = "/documents";
    var delivery = "/delivery";
    var usages = "/usages";
    var search = "/search";
    var dataExport = "/data-export";
    var royaltyStatement = "/royalty-statement";
    var izenda7Reporting = "/izenda-7";
    var characteristics = "/characteristics";
    var groups = "/groups";
    var hierarchy = "/hierarchy";
    var party = "/party";
    var template = "/template";
    var workflow = "/workflow";
    var policy = "/policy";
    var summary = "/summary";
    var bulkContactOverwrite = site + "/bulk-contact-overwrite";
    var dataImport = "/data-import";
    var ssrsReports = "/ssrsreports";
    var financials = "/financials";
    var files = "/files";
    var availabilities = "/availabilities";
    var comments = "/comments";

    var divAdmin = site + "/div-admin";
    var userAdmin = "/user-admin";
    var currencyAdmin = "/currency-admin";
    var overView = "/overview";
    var statusUpdate = "/status-update-admin";
    var billingAdmin = "/billing-admin";
    var dataImport = "/data-import";
    var dataUpdate = "/data-update";
    var dataExport = "/data-export"
    var dataImportV2 = "/data-importV2"

    var dataHost = AclProtocol + "://data";
    var entities = "/entities"

    export var Activities = {
        Site: site,
        _Site: {
            Mod1: mod1,
            _Mod1: {
                Details: mod1 + details,
                Contacts: mod1 + contacts,
                Association: mod1 + association,
                Associationv2: mod1 + associationv2,
                Rights: mod1 + rights,
                Availabilities: mod1 + availabilities,
                Deals: mod1 + deals,
                Finacials: mod1 + financials,
                Usages: mod1 + usages,
                Files: mod1 + files,
                Media: mod1 + media,
                Comments: mod1 + comments
            },
            Mod2: mod2,
            _Mod2: {
                Details: mod2 + details,
                Security: mod2 + security,
                Deals: mod2 + deals,
                Association: mod2 + association,
                Associationv2: mod2 + associationv2,
                Accounting: mod2 + accounting,
                Usages: mod2 + usages,
                Comments: mod2 + comments
            },
            Mod4: mod4,
            _Mod4: {
                Details: mod4 + details,
                Contacts: mod4 + contacts,
                Rights: mod4 + rights,
                Royalties: mod4 + royalties,
                Assets: mod4 + assets,
                Inventory: mod4 + inventory,
                Accounting: mod4 + accounting,
                Documents: mod4 + documents,
                Delivery: mod4 + delivery,
                Associationv2: mod4 + associationv2,
                Usages: mod4 + usages,
                Summary: mod4 + summary,
                Comments: mod4 + comments
            },
            Mod7: mod7,
            _Mod7: {
                Details: mod7 + details,
                Contacts: mod7 + contacts,
                Projects: mod7 + projects,
                Comments: mod7 + comments
            },
            Mod17: mod17,
            _Mod17: {
                Details: mod17 + details,
                Media: mod17 + media,
                Deals: mod17 + deals,
                Associationv2: mod17 + associationv2,
                Contacts: mod17 + contacts,
                Usages: mod17 + usages,
                Comments: mod17 + comments
            },
            Mod14: mod14,
            _Mod14: {
                Details: mod14 + details,
            },
            Mod15: mod15,
            _Mod15: {
                Details: mod15 + details,
                Files: mod15 + files,
                Association: mod15 + association,
                Usages: mod15 + usages,
                Inventory: mod15 + inventory,
                Contacts: mod15 + contacts,
                Comments: mod15 + comments
            },
            Mod16: mod16,
            _Mod16: {
                Details: mod16 + details,
                Files: mod16 + files,
                Association: mod16 + association,
                Usages: mod16 + usages,
                Contacts: mod16 + contacts,
                Comments: mod16 + comments
            },
            BulkContactOverwrite: bulkContactOverwrite,
            Reports: reports,
            _Reports: {
                Search: reports + search,
                DataExport: reports + dataExport,
                RoyaltyStatement: reports + royaltyStatement,
                SSRSReports: reports + ssrsReports,
                DataImport: reports + dataImport,
                Izenda7: reports + izenda7Reporting
            },
            Configuration: configuraton,
            _Configuration: {
                Characteristics: configuraton + characteristics,
                Documents: configuraton + documents,
                Groups: configuraton + groups,
                Hierarchy: configuraton + hierarchy,
                Party: configuraton + party,
                Security: configuraton + security,
                Template: configuraton + template,
                Workflow: configuraton + workflow,
                Policy: configuraton + policy
            },
            DivAdmin: divAdmin,
            _DivAdmin: {
                OverView: divAdmin + overView,
                UserAdmin: divAdmin + userAdmin,
                CurrencyAdmin: divAdmin + currencyAdmin,
                BillingAdmin: divAdmin + billingAdmin,
                StatusUpdate: divAdmin + statusUpdate,
                DataImport: divAdmin + dataImport,
                DataImportV2: divAdmin + dataImportV2,
                DataUpdate: divAdmin + dataUpdate,
                DataExport: divAdmin + dataExport
            }
        },
        Admin: admin,
        _Admin: {}
    };

    export var Data = {
        entities: dataHost + entities
    };
}

export namespace CharTypeIDs {
    export var relationship = 0;
    export var property = 1;
    export var user = 2;
    export var right = 3;
    export var transaction = 4;
    export var usage = 5;
    export var company = 6;
    export var invoice = 7;
    export var report = 8;
    export var parameter = 9;
    export var amount = 10;
    export var period = 11;
    export var date = 12;
    export var royalty = 13;
    export var document = 14;
    export var job = 15;
    export var project = 16;
    export var inventory = 17;
    export var mock = 99;
}

export namespace PluralCharTypeNames {
    var ids = {};
    ids[CharTypeIDs.relationship] = "Relationships";
    ids[CharTypeIDs.property] = "Catalog";
    ids[CharTypeIDs.user] = "Contacts";
    ids[CharTypeIDs.right] = "Rights";
    ids[CharTypeIDs.transaction] = "Deals";
    ids[CharTypeIDs.usage] = "Tables";
    ids[CharTypeIDs.invoice] = "Accounting";
    ids[CharTypeIDs.amount] = "Amounts";
    ids[CharTypeIDs.royalty] = "Royalties";
    ids[CharTypeIDs.document] = "Documents";
    ids[CharTypeIDs.inventory] = "Inventory";
    ids[CharTypeIDs.job] = "Jobs";
    ids[CharTypeIDs.project] = "Projects";
    export var IDs = (() => { return ids; })();
}

export namespace CharTypeNames {
    var ids = {};
    ids[CharTypeIDs.relationship] = "Relationship";
    ids[CharTypeIDs.property] = "Catalog Item";
    ids[CharTypeIDs.user] = "Contact";
    ids[CharTypeIDs.right] = "Right";
    ids[CharTypeIDs.transaction] = "Deal";
    ids[CharTypeIDs.usage] = "Table";
    ids[CharTypeIDs.invoice] = "Accounting Document";
    ids[CharTypeIDs.amount] = "Amount";
    ids[CharTypeIDs.royalty] = "Royalty";
    ids[CharTypeIDs.document] = "Document";
    ids[CharTypeIDs.inventory] = "Inventory";
    ids[CharTypeIDs.job] = "Job";
    ids[CharTypeIDs.project] = "Project";
    export var IDs = (() => { return ids; })();
}

export namespace DefaultImages {
    export var KeyartMissing = "/assets/img/keyart_missing.png";
}

export namespace PreviewTypes {
    export var Other = "other";
    export var Image = "image";
    export var Video = "video";
    export var PreviewableExtensions: string[] = [".doc", ".pdf", ".jpg", ".jpeg", ".png", ".gif"];
}
export namespace PreviewLoadingPage {
    export var HtmlFile = "/assets/app/templates/doc-viewer-loading.html";
}

export namespace PreviewMSOfficeDocUrl {
    export var msOfficeLiveUrl = "https://view.officeapps.live.com/op/view.aspx?src=";
}


export var userDivAppUrlHash = window["userDivAppUrlHash"];
export var userEmail = window["userEmail"];
export var fileStackKey = window["fileStackKey"];

export namespace PositionState {
    export var none = 0;
    export var before = 1;
    export var onto = 2;
    export var after = 3;
}
export namespace LicenseDocGenActionIDs {
    export var CreateAgreement = 4;
    export var RedraftAgreement = 18;
}
export namespace InvoiceDocGenActionIDs {
    export var DraftBillingDoc = 2;
}

export namespace WorkflowStepActiveIndicator {
    export var InActive = 0;
    export var Active = 1;
}

var rlAdminConstsModule = angular.module("rlAdminConsts", []);

//TODO: Learn TypeScript and create this as a class? - Crabb
rlAdminConstsModule.constant("charTypeIcons", [
    {
        name: 'Catalog Item',
        charTypeID: 1,
        class: 'icon icon-archive'
    },
    {
        name: 'User',
        charTypeID: 2,
        class: 'icon icon-user'
    },
    {
        name: 'Deal',
        charTypeID: 4,
        class: 'icon icon-briefcase'
    },
    {
        name: 'Invoice',
        charTypeID: 7,
        class: 'fa fa-money'
    },
    {
        name: 'Inventory',
        charTypeID: 17,
        class: 'icon icon-barcode'
    }, {
        name: 'Project',
        charTypeID: 16,
        class: 'icon icon-light-bulb'
    },
    {
        name: 'Jobs',
        charTypeID: 15,
        class: 'fa fa-clipboard'
    },
    {
        name: 'Rights',
        charTypeID: 3,
        class: 'fa fa-registered'
    },
    {
        name: 'Table',
        charTypeID: 5,
        class: 'fa fa-table'
    },
    {
        name: 'Amounts',
        charTypeID: 10,
        class: 'fa fa-list-ul'
    },
    {
        name: 'Royalties',
        charTypeID: 13,
        class: 'fa fa-percent'
    },
    {
        name: 'Documents',
        charTypeID: 14,
        class: 'fa fa-file-text-o'
    }
]);

export { rlAdminConstsModule };

export namespace CharDataTypeIDs {
    export enum CharDataTypes {
        year = 1,
        url = 2,
        alphanumeric = 3,
        numeric = 4,
        date = 5,
        email = 6,
        currency = 7,
        percentage = 8,
        password = 9,
        timecode = 10,
        creditcard = 11,
        file = 12,
        checkbox = 13,
        money = 14
    }
}

export namespace PointOfProcess {
    export var middleAction = 0;
    export var initialAction = 1;
    export var finalAction = 2;
}

export namespace ChildCharTypes {
    var ids = {};
    ids[CharTypeIDs.property] = CharTypeIDs.property;
    ids[CharTypeIDs.inventory] = CharTypeIDs.inventory;
    ids[CharTypeIDs.right] = CharTypeIDs.right;
    ids[CharTypeIDs.usage] = CharTypeIDs.usage;
    ids[CharTypeIDs.invoice] = CharTypeIDs.invoice;
    export var IDs = (() => { return ids; })();
}

export namespace AllowMultipleParentCharTypes {
    var ids = {};
    ids[CharTypeIDs.right] = CharTypeIDs.right;
    ids[CharTypeIDs.usage] = CharTypeIDs.usage;
    ids[CharTypeIDs.royalty] = CharTypeIDs.royalty;
    export var IDs = (() => { return ids; })();
}


export namespace ModuleLevelCharTypes {
    var ids = {};
    ids[CharTypeIDs.property] = CharTypeIDs.property;
    ids[CharTypeIDs.inventory] = CharTypeIDs.inventory;
    ids[CharTypeIDs.user] = CharTypeIDs.user;
    ids[CharTypeIDs.transaction] = CharTypeIDs.transaction;
    ids[CharTypeIDs.invoice] = CharTypeIDs.invoice;
    ids[CharTypeIDs.project] = CharTypeIDs.project;
    ids[CharTypeIDs.job] = CharTypeIDs.job;
    export var IDs = (() => { return ids; })();
}

export namespace NotBulkUploadCharTypes {
    var ids = {};
    ids[CharTypeIDs.document] = CharTypeIDs.document;
    export var IDs = (() => { return ids; })();
}

export namespace AllowedNestedCharTypes {
    var ids = {};
    ids[CharTypeIDs.property] = CharTypeIDs.property;
    ids[CharTypeIDs.user] = CharTypeIDs.user;
    ids[CharTypeIDs.project] = CharTypeIDs.project;
    ids[CharTypeIDs.usage] = CharTypeIDs.usage;
    export var IDs = (() => { return ids; })();
}

export namespace WorkflowExtPathType {
    export var ExecuteStoreProcedure = 1;
    export var ExecuteService = 3;
}

export namespace DivSettingKey {
    export var CurrencyKey = "division_currency_value_id";
    export var AutoSyncDealCatalogRights = "autoSyncDealCatalogRights";
    export var CatalogMetaSyncDeleteIfNull = "catalogMetaSyncDeleteIfNull";
}

export namespace DateMath {
    export var BlankDateValue = "09/09/1900";
    export var PerpetutityDateValue = "09/09/9999";
}

export namespace Caching {
    export var Enabled = true;
}

export namespace AdvancedSearch {
    export enum Operator {
        And = 0,
        Or = 1
    }

    export enum Comparator {
        Contains = 0,
        ContainsAll = 1,
        NotContains = 2,
        EqualAny = 3,
        Equal = 4,
        NotEqual = 5,
        LessThan = 6,
        GreaterThan = 7,
        Between = 8
    }
}

export namespace SyncMode {
    export var SyncAllContactParties = 1;
    export var SyncContactParty = 2;
    export var SyncAllCharacteristics = 3;
    export var SyncCharacteristics = 4;
}

export namespace AuditHistory {
    export enum Operation {
        Added = 2,
        Changed = 4,
        Deleted = 1
    }
}

export namespace ExecutableExtensions {
    export var Types: string[] = ["action", "apk", "app", "bat", "bin", "cmd", "com", "command", "cpl", "csh", "exe", "gadget", "html", "inf1", "ins", "inx", "ipa", "isu", "job", "jse", "ksh", "lnk", "msc", "msi", "msp", "mst", "osx", "out", "paf", "pif", "prg", "ps1", "reg", "rgs", "run", "scr", "sct", "shb", "shs", "u3p", "vb", "vbe", "vbs", "vbscript", "workflow", "ws", "wsf", "wsh", "0xe", "73k", "89k", "a6p", "ac", "acc", "acr", "actm", "ahk", "air", "app", "arscript", "as", "asb", "awk", "azw2", "beam", "btm", "cel", "celx", "chm", "cof", "crt", "dek", "dld", "dmc", "docm", "dotm", "dxl", "ear", "ebm", "ebs", "ebs2", "ecf", "eham", "elf", "es", "ex4", "exopc", "ezs", "fas", "fky", "fpi", "frs", "fxp", "gs", "ham", "hms", "hpf", "hta", "iim", "ipf", "isp", "jar", "js", "jsx", "kix", "lo", "ls", "mam", "mcr", "mel", "mpx", "mrc", "ms", "ms", "mxe", "nexe", "obs", "ore", "otm", "pex", "plx", "potm", "ppam", "ppsm", "pptm", "prc", "pvd", "pwc", "pyc", "pyo", "qpx", "rbx", "rox", "rpj", "s2a", "sbs", "sca", "scar", "scb", "script", "smm", "spr", "tcp", "thm", "tlb", "tms", "udf", "upx", "url", "vlx", "vpm", "wcm", "widget", "wiz", "wpk", "wpm", "xap", "xbap", "xlam", "xlm", "xlsm", "xltm", "xqt", "xys", "zl9"];
}

export namespace ReportNameSpace {
    export var SSRSReports = "SSRSReport";
    export var OOTBAvails = "OOTBAvails";
    export var QuickLinks = "QuickLink"
}

export namespace IsGlobal {
    export var Yes = 1;
    export var No = 0;

}

export namespace Messages {
    export var InvRqdVal = "INV-RQD-VAL";
    export var InvNonMultiVal = "INV-NON-MULTI-VAL";
    export var InvLovVal = "INV-LOV-VAL";
    export var InvYear = "INV-YEAR";
    export var InvUrl = "INV-URL";
    export var InvNum = "INV-NUM";
    export var InvDate = "INV-DATE";
    export var InvEml = "INV-EML";
    export var InvPerc = "INV-PERC";
    export var InvRgtCat = "INV-RGT-CAT";
    export var InvNoAssoc = "INV-NO-ASSOC";
    export var InvInactvAssoc = "INV-INACTV-ASSOC";
    export var InvDupe = "INV-DUPE";
    export var InvMxdCur = "INV-MXD-CUR";
    export var InvRqdPty = "INV-RQD-PTY";
    export var InvNonMultiPty = "INV-NON-MULTI-PTY";
    export var InvTmpPty = "INV-TMP-PTY";
    export var InvDiv59RptTag = "INV-DIV-59-RPT-TAG";
    export var InvDiv59Exp = "INV-DIV-59-EXP";
    export var InvDiv59RptLne = "INV-DIV-59-RPT-LNE";
    export var InvDiv59Alloc = "INV-DIV-59-ALLOC";
    export var GenErr = "GEN-ERR";


}